<template>
  <button
    type="button"
    @click.prevent="generateBookAllFile"
    class="btn btn-primary btn-sm px-3"
    v-if="!ms_bookAllFilePath && !immLoading"
  >
    批量下载
  </button>
  <button
    type="button"
    class="btn btn-primary btn-sm"
    v-else-if="!ms_bookAllFilePath && immLoading"
  >
    正在生成链接...
  </button>
  <a
    :href="ms_bookAllFilePath"
    target="_blank"
    class="btn btn-primary btn-sm px-3"
    v-else
    >下载压缩包</a
  >
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

//import { generateBookAllFile } from '@/global/service';

export default {
  name: 'ButtonBookAllFile',

  components: {},

  props: {
    p_courseId: {
      type: Number,
      default: () => 0,
    },

    p_bookId: {
      type: Number,
      default: () => 0,
    },

    p_mode: {
      type: String,
      default: () => '',
    },
  },

  data: () => {
    return {};
  },

  computed: {
    ...mapState({
      ms_bookAllFilePath: 'bookAllFilePath',
    }),

    ...mapGetters({
      loading: 'loading',
      immLoading: 'immLoading',
      aopLoading: 'aopLoading',
      userInfo: 'userInfo',
    }),
  },

  methods: {
    ...mapActions({
      ma_generateBookAllFile: 'generateBookAllFile',
    }),

    async generateBookAllFile() {
      await this.ma_generateBookAllFile({
        courseId: this.p_courseId,
        bookId: this.p_bookId,
        mode: this.p_mode,
      });
    },
  },

  mounted() {
    this.ma_generateBookAllFile({
      isClear: true,
    });
  },
};
</script>
<style lang="scss" scoped></style>
